document.addEventListener("DOMContentLoaded", () => {
  const productListContainers = document.querySelectorAll(
    ".product-list__container"
  );

  productListContainers.forEach((container) => {
    const productList = container.querySelector(".product-list");
    const leftButton = container.querySelector(
      ".product-list__scroll-button--left"
    );
    const rightButton = container.querySelector(
      ".product-list__scroll-button--right"
    );

    if (!productList || !leftButton || !rightButton) return;

    let startX = 0;
    let startY = 0;
    let initialTouchX = 0;
    let initialTouchY = 0;
    let scrollLeft = 0;
    let isMouseDown = false;

    const getScrollAmount = () => {
      const card = productList.querySelector(".product-card");
      if (!card) return 0;
      return card.offsetWidth + parseInt(getComputedStyle(card).marginRight);
    };

    const scroll = (direction) => {
      const amount = getScrollAmount();
      if (amount === 0) return;

      // Usar scrollBy ao invés de scrollTo para melhor suporte em iOS
      productList.scrollBy({
        left: amount * direction,
        behavior: "smooth",
        // Adicionar duração específica para iOS
        duration: 300,
      });
    };

    const updateButtons = () => {
      const isStart = productList.scrollLeft <= 0;
      const isEnd =
        productList.scrollLeft + productList.clientWidth >=
        productList.scrollWidth - 1;

      leftButton.classList.toggle("disabled", isStart);
      rightButton.classList.toggle("disabled", isEnd);
    };

    // Touch/Mouse events
    const handleDragStart = (e) => {
      isMouseDown = true;
      startX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      startY = e.type.includes("mouse") ? e.pageY : e.touches[0].pageY;
      initialTouchX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      initialTouchY = e.type.includes("mouse") ? e.pageY : e.touches[0].pageY;
      scrollLeft = productList.scrollLeft;
      productList.style.scrollBehavior = "auto";
    };

    const handleDragMove = (e) => {
      if (!isMouseDown) return;

      const currentX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      const currentY = e.type.includes("mouse") ? e.pageY : e.touches[0].pageY;

      // Calculate the difference in horizontal and vertical movement
      const deltaX = Math.abs(currentX - initialTouchX);
      const deltaY = Math.abs(currentY - initialTouchY);

      // If horizontal movement is greater than vertical, prevent page scroll
      if (deltaX > deltaY) {
        e.preventDefault();
        const distance = (currentX - startX) * 2;
        productList.scrollLeft = scrollLeft - distance;
      }
    };

    const handleDragEnd = () => {
      isMouseDown = false;
      // Forçar comportamento suave após o drag
      requestAnimationFrame(() => {
        productList.style.scrollBehavior = "smooth";
      });
    };

    // Event Listeners
    leftButton.addEventListener("touchstart", (e) => {
      e.preventDefault();
      scroll(-1);
    });
    rightButton.addEventListener("touchstart", (e) => {
      e.preventDefault();
      scroll(1);
    });

    leftButton.addEventListener("click", () => scroll(-1));
    rightButton.addEventListener("click", () => scroll(1));

    // Touch events
    productList.addEventListener("touchstart", handleDragStart);
    productList.addEventListener("touchmove", handleDragMove);
    productList.addEventListener("touchend", handleDragEnd);

    // Mouse events
    productList.addEventListener("mousedown", handleDragStart);
    productList.addEventListener("mousemove", handleDragMove);
    productList.addEventListener("mouseup", handleDragEnd);
    productList.addEventListener("mouseleave", handleDragEnd);

    // Scroll and resize events
    productList.addEventListener("scroll", updateButtons);
    window.addEventListener("resize", updateButtons);

    // Initial setup
    updateButtons();
  });
});
